import { ContentCard, PersonSummaryWithPhoto } from '../types';

/**
 * Get the correct URL path for a content item based on its type
 */
export const getContentUrl = (content: ContentCard): string => {
  if (content.type === 'movie') {
    return `/movies/${content.id}`;
  } else if (content.type === 'tv') {
    return `/shows/${content.id}`;
  }
  
  // Fallback to player for unknown types
  return `/player/${content.id}`;
};

/**
 * Get the URL path for a person detail page
 */
export const getPersonUrl = (person: PersonSummaryWithPhoto): string => {
  return `/person/${person.id}`;
};

/**
 * Navigate to content using the correct URL structure
 */
export const navigateToContent = (navigate: (path: string) => void, content: ContentCard): void => {
  navigate(getContentUrl(content));
};

/**
 * Navigate to person detail page
 */
export const navigateToPerson = (navigate: (path: string) => void, person: PersonSummaryWithPhoto): void => {
  navigate(getPersonUrl(person));
};

/**
 * Check if a person has a detail page available
 * For now, we assume all persons with an ID have a detail page
 * This can be enhanced later with API checks if needed
 */
export const hasPersonDetailPage = (person: PersonSummaryWithPhoto): boolean => {
  return !!(person.id && person.id.trim());
};